const styles = {
  container: {},
  title: {
    color: 'kit.text.main',
    marginBottom: '32px',
  },
};

export default styles;
